export default __webpack_public_path__ + "static/media/fltbd_rc_mobile_phone_1.5052426e.png";